(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dina-experiences"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(scope){
    scope.querySelectorAll('.dina-experiences').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='1';
      var track=root.querySelector('.dina-experiences__track');
      var cards=Array.from(track.querySelectorAll('.dina-experiences__card'));
      var dots=Array.from(root.querySelectorAll('.dina-experiences__dots button'));
      var prev=root.querySelector('[data-dina-prev]');
      var next=root.querySelector('[data-dina-next]');
      var frame;
      function active(){
        var viewport=track.getBoundingClientRect();
        var center=viewport.left+viewport.width/2;
        var index=0,best=Infinity;
        cards.forEach(function(card,i){
          var rect=card.getBoundingClientRect();
          var distance=Math.abs(rect.left+rect.width/2-center);
          if(distance<best){best=distance;index=i;}
        });
        dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-pressed',i===index?'true':'false');});
        prev.disabled=index===0;
        next.disabled=index===cards.length-1;
        return index;
      }
      function go(index){
        index=Math.max(0,Math.min(cards.length-1,index));
        var card=cards[index].getBoundingClientRect();
        var viewport=track.getBoundingClientRect();
        track.scrollTo({left:track.scrollLeft+card.left-viewport.left-(viewport.width-card.width)/2,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      prev.addEventListener('click',function(){go(active()-1);});
      next.addEventListener('click',function(){go(active()+1);});
      dots.forEach(function(dot,i){dot.addEventListener('click',function(){go(i);});});
      track.addEventListener('keydown',function(event){
        if(event.target!==track)return;
        if(event.key==='ArrowRight'){event.preventDefault();go(active()+1);}
        if(event.key==='ArrowLeft'){event.preventDefault();go(active()-1);}
      });
      track.addEventListener('scroll',function(){cancelAnimationFrame(frame);frame=requestAnimationFrame(active);},{passive:true});
      if(window.ResizeObserver)new ResizeObserver(active).observe(track);
      active();
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);});}else{init(document);}
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
  } catch(e) { console.error(e); }
})();

})();
